import theme from '../theme';

const telColor = (status: string) => {
  const telColors: {[key: string]: string} = theme.status.tel;
  return telColors[status];
};

export default telColor;
